import { barnToolsApi } from './base';
import { IGatewayGroupCollection } from './types';

export const gatewayGroupApi = barnToolsApi
  .enhanceEndpoints({ addTagTypes: ['gatewaysGroups'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getGatewayGroups: builder.query<
        IGatewayGroupCollection,
        {
          organizationId: string;
          includeGateways?: boolean;
          includeAssignedUsers?: boolean;
          forGateway?: string;
        }
      >({
        query: (args) => {
          const params: Record<string, unknown> = {
            orgids: args.organizationId,
          };
          const expands = [];
          if (args.includeGateways) {
            expands.push('gateways');
          }
          if (args.includeAssignedUsers) {
            expands.push('assignedUsers');
          }
          if (expands.length > 0) {
            params['$expand'] = expands.join(',');
          }
          if (args.forGateway) {
            params['gateway'] = args.forGateway;
          }

          return {
            url: `organizations/${args.organizationId}/gatewayGroups`,
            params: params,
          };
        },
        providesTags: ['gatewaysGroups'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetGatewayGroupsQuery } = gatewayGroupApi;
